export const setTimeOutSync = (cb) => {
  return new Promise((res) => {
    setTimeout(() => {
      cb(); // Execute the callback function after the timeout
      res();
    }, 1000);
  });
};
